export default __webpack_public_path__ + "static/media/overviewBg@2x.f0831701.png";